module.exports = __webpack_public_path__ + "static/media/13b.0e5f10b3.svg";